<template>
    <div>
        <div class="d-flex flex-row justify-content-between text-secondary">
            <span class="small">Номер лота: {{ lot.lot_number }}</span>
            <span class="small">{{ getDisplayStatus() }}</span>
        </div>
        <div>
            {{ lot.name }}
        </div>
        <div>
            <span class="small text-secondary">Организатор: {{ lot.org_name }}</span>
        </div>
    </div>
</template>

<script>
    import {LOT_STATUSES_LIST as statuses} from "@features/Lots/helpers";
    export default {
        name: "AuctionListDescription",
        props: {
            lot: {
                type: Object,
                required: true
            }
        },
        methods: {
            getDisplayStatus() {
                const status = statuses.find( status => status.value === this.lot.status).text ?? 'статус не определен'
                return status
            }
        }
    }
</script>
